import { Action } from '../../infra/types'
import { SettingsAction } from './settings.action'
import { SettingsState } from './settings.state'
import { ISettingsState } from './settings.types'

export const SettingsReducer = (
  state: ISettingsState = SettingsState,
  action: Action<any>
): ISettingsState => {
  switch (action.type) {
    case SettingsAction.SET_SETTINGS_LOADERS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          [action.payload.loaderName]: action.payload.status
        }
      }
    }
    case SettingsAction.SET_STAFF_LOCATION_TRAVELLED: {
      return {
        ...state,
        distance: {
          ...state.distance,
          [action.payload.staffId]: action.payload.distance
        }
      }
    }
    case SettingsAction.SET_SETTINGS_DRAWER: {
      return {
        ...state,
        drawers: {
          ...state.drawers,
          [action.payload.id]: action.payload.value
        }
      }
    }
    case SettingsAction.FETCH_OVERALL_BUSINESS_SETTINGS_SUCCESS: {
      return {
        ...state,
        businessSettings: action.payload
      }
    }
    case SettingsAction.RESET_LOADERS: {
      return {
        ...state,
        loaders: {
          orderSettingLoader: false,
          livesaleSettingLoader: false
        }
      }
    }
    case SettingsAction.SET_GDRIVE_STATUS: {
      return {
        ...state,
        gdrive: {
          ...state.gdrive,
          ...action.payload
        }
      }
    }
    case SettingsAction.SET_GDRIVE_LOADING: {
      return {
        ...state,
        gdrive: {
          ...state.gdrive,
          loading: action.payload
        }
      }
    }
    case SettingsAction.SET_GDRIVE_SYNCING: {
      return {
        ...state,
        gdrive: {
          ...state.gdrive,
          syncing: action.payload
        }
      }
    }
    default: {
      return state
    }
  }
}
